import { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isOverflowActive } from "../../../../common/utils";
import { Tooltip } from "antd";

const EllipsesText = ({
  color,
  children,
  tooltipContent,
  style,
  navigateUrl,
}: any) => {
  const ref = useRef(null);
  const navigate = useNavigate();
  const [overflowActive, setOverflowActive] = useState(false);

  useEffect(() => {
    if (isOverflowActive(ref.current)) {
      setOverflowActive(true);
      return;
    }
    setOverflowActive(false);
  }, []);

  const EllipsizedContent = (
    <div
      style={{
        maxWidth: "350px",
        width: "auto",
        color: color,
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: navigateUrl ? "pointer" : "default",
        ...style,
      }}
      ref={(el: any) => {
        if (ref) ref.current = el;
      }}
      onClick={() => {
        navigateUrl && navigate(navigateUrl);
      }}
    >
      {children}
    </div>
  );
  return (
    <Fragment>
      {overflowActive ? (
        <Tooltip title={tooltipContent}>{EllipsizedContent}</Tooltip>
      ) : (
        EllipsizedContent
      )}
    </Fragment>
  );
};

export default EllipsesText;
